import clsx from 'clsx';
import Image from 'next/image';

export function Logomark(props) {
  return (
    <img
      width={32}
      height={32}
      src="/img/okgrow-black-logo.svg"
      loading="eager"
      alt="OkGrow logo icon"
      title='OkGrow logo icon'
      priority={true}
      color='red'
      {...props}
    />
    // <svg viewBox="0 0 40 40" aria-hidden="true" {...props}>
    //   <path
    //     fillRule="evenodd"
    //     clipRule="evenodd"
    //     d="M20 40C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20ZM4 20c0 7.264 5.163 13.321 12.02 14.704C17.642 35.03 19 33.657 19 32V8c0-1.657-1.357-3.031-2.98-2.704C9.162 6.68 4 12.736 4 20Z"
    //   />
    // </svg>
  );
}

export function LogomarkSVG(props) {
  return (
    <svg data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 364 364" {...props}>
      <g data-name="Layer 1">
        <rect fill="currentColor" y="0" width="364" height="364" rx="80" ry="80" />
        <path fill="#fff" d="M276.94,211.12v18.28h14.65c-5.56,6.6-14.62,14.76-25.47,14.76-5.3,0-10.52-2.3-14.69-6.49-4.37-4.39-7.32-10.38-8.61-17.35,23.75-3.07,38.59-17.42,38.59-38.29,0-19.01-12.63-32.29-30.71-32.29-15.14,0-28.43,7.49-39.36,21.62l8.12-63.59-18.14-2.32c-3.84,30.09-14.1,50.95-30.62,62.41-1.57-18.09-7.16-33.64-16.41-45.42-10.42-13.28-25.2-20.89-40.54-20.89-20.4,0-41.05,13.69-41.05,39.85,0,32.53,32.18,55.2,61.05,55.2,6.19,0,12.08-.53,17.68-1.56-5.19,28.55-23.73,49.11-46.42,49.11-27.2,0-45.47-23.04-45.47-57.33,0-11.87,4.99-23.33,5.04-23.44l-16.7-7.43c-.27.61-6.62,15.01-6.62,30.88,0,44.52,26.22,75.62,63.75,75.62,34.36,0,61.82-31.56,65.69-73.54,8.31-3.93,15.68-9.34,22.04-16.16l-11.05,86.57,18.14,2.32c7.48-58.6,26.5-93.59,50.88-93.59,11.22,0,12.43,9.79,12.43,14,0,6.2-2.94,20.62-30.19,20.62h-9.11l-.03,9.11c-.05,15.47,5.16,29.25,14.68,38.81,7.63,7.65,17.44,11.87,27.64,11.87,17.11,0,30.3-10.88,38.37-20.03v14.52h18.28v-45.82h-45.82ZM133.74,178.33c-24.48,0-42.77-19.49-42.77-36.92,0-20.96,20.44-21.57,22.77-21.57,24.91,0,38.3,27.83,39.09,56.17-5.86,1.54-12.22,2.32-19.09,2.32Z" />
      </g>
    </svg>
  );
}
export function Logo(props) {
  return (
    <div className={clsx('group flex items-center gap-2', props.className, props.center ? '!justify-center' : '')}>
      {/* {!props.hideIcon && (
        <Logomark
          width="32"
          height="32"
          className="inline-block h-8 w-auto transform transform-gpu transition-all duration-500 ease-in-out group-hover:translate-x-1 group-hover:rotate-[360deg] group-hover:scale-[87%]"
        />
      )} */}

      {!props.hideText && (
        <Image
          width={135}
          height={20}
          // src="/img/upgrow-logo-text.svg"
          src="/img/okgrow-logo-text.svg"
          loading="eager"
          alt="OkGrow logo"
          title='OkGrow logo'
          className="inline-block w-auto h-5 mt-2"
          priority={true}
        />
      )}

      {props.showBadge && (
        <span className="inline-block"
          style={{
            marginLeft: '5px',
            background: '#000',
            color: 'white',
            padding: '3px 9px',
            borderRadius: '8px',
            fontFamily: 'Gtwalsheimpro,sans-serif',
            fontWeight: 700,
            WebkitFontSmoothing: 'antialiased',
            fontSize: '13px',
          }}
        >
          GPT-4 Powered
        </span>
      )}
    </div>
  );
}
